import React from "react";
import { FaHtml5, FaPhp, FaReact, FaJs, FaDatabase, FaCogs, FaProjectDiagram, FaCode, FaJava, FaCss3, FaPython, FaJira } from 'react-icons/fa';
import { DiLaravel, DiScriptcs, DiJqueryLogo } from 'react-icons/di';

function SolucoesInovadoras() {
  return (
    <section id="section-tech" style={styles.container}>
      <h2 style={styles.title}>Tecnologias que Uso</h2>

      <div style={styles.technologies}>
        <div style={styles.cardsContainer}>
          {/* Linguagens */}
          <div style={styles.card}>
            <FaHtml5 size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>HTML</h4>
            <p style={styles.cardText}>Estruturação de conteúdo para web com HTML5, criando layouts responsivos.</p>
          </div>

          <div style={styles.card}>
            <FaPhp size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>PHP</h4>
            <p style={styles.cardText}>Desenvolvimento de sistemas back-end dinâmicos com PHP, integrando bancos de dados.</p>
          </div>

          <div style={styles.card}>
            <FaJs size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>JavaScript</h4>
            <p style={styles.cardText}>Desenvolvimento de funcionalidades e interações ricas para páginas web com JavaScript.</p>
          </div>

          <div style={styles.card}>
            <FaReact size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>React</h4>
            <p style={styles.cardText}>Criação de interfaces dinâmicas e interativas com React.js, focando na performance.</p>
          </div>

          <div style={styles.card}>
            <FaDatabase size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>SQL Server</h4>
            <p style={styles.cardText}>Consultas e manipulação de dados com SQL Server, garantindo desempenho e integridade.</p>
          </div>

          <div style={styles.card}>
            <FaCogs size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>Laravel</h4>
            <p style={styles.cardText}>Framework PHP para desenvolvimento rápido e eficiente de sistemas web.</p>
          </div>

          <div style={styles.card}>
            <FaPhp size={40} style={styles.icon} /> {/* Substituímos DiCakephp por FaPhp */}
            <h4 style={styles.cardTitle}>CakePHP</h4>
            <p style={styles.cardText}>Framework PHP focado em desenvolvimento rápido de aplicações web robustas.</p>
          </div>

          <div style={styles.card}>
            <DiScriptcs size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>ScriptCase</h4>
            <p style={styles.cardText}>Ferramenta de desenvolvimento rápido de aplicações web com PHP.</p>
          </div>

          <div style={styles.card}>
            <FaCode size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>C++</h4>
            <p style={styles.cardText}>Desenvolvimento de aplicações de alto desempenho com C++.</p>
          </div>

          <div style={styles.card}>
            <FaCss3 size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>CSS</h4>
            <p style={styles.cardText}>Estilização de páginas web com CSS3, criando layouts responsivos e modernos.</p>
          </div>

          <div style={styles.card}>
            <FaPython size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>Python</h4>
            <p style={styles.cardText}>Desenvolvimento de scripts, automação e sistemas com Python.</p>
          </div>

          <div style={styles.card}>
            <FaJira size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>Metodologias Ágeis</h4>
            <p style={styles.cardText}>Aplicação de PM Canvas, Kanban e Scrum para gestão eficiente de projetos.</p>
          </div>

          <div style={styles.card}>
            <FaDatabase size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>Oracle SQL Developer</h4>
            <p style={styles.cardText}>Ferramenta para administração de bancos de dados Oracle, criação de consultas e manutenção.</p>
          </div>

          <div style={styles.card}>
            <FaJira size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>ServiceNow</h4>
            <p style={styles.cardText}>Plataforma para gerenciamento de TI com certificações em CMDB, Agile e Test Management.</p>
          </div>

          <div style={styles.card}>
            <DiJqueryLogo size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>JQuery</h4>
            <p style={styles.cardText}>Biblioteca JavaScript para simplificar a manipulação de DOM e eventos.</p>
          </div>

          <div style={styles.card}>
            <FaProjectDiagram size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>API de Pagamento</h4>
            <p style={styles.cardText}>Integração com APIs de pagamento como Stripe e PagBank.</p>
          </div>

          <div style={styles.card}>
            <FaProjectDiagram size={40} style={styles.icon} />
            <h4 style={styles.cardTitle}>API</h4>
            <p style={styles.cardText}>Desenvolvimento de APIs RESTful para integração de sistemas.</p>
          </div>

        </div>
      </div>
    </section>
  );
}

const styles = {
  container: {
    backgroundColor: "#F4F4F4",
    padding: "60px 20px",
    textAlign: "center",
  },
  title: {
    fontSize: "32px",
    color: "#333",
    marginBottom: "30px",
    fontWeight: "bold",
  },
  technologies: {
    marginBottom: "50px",
  },
  cardsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "20px", // Espaçamento entre os cards
    flexWrap: "wrap", // Permite que os cards se ajustem quando não cabem na linha
  },
  card: {
    backgroundColor: "#FFF",
    width: "280px", // Largura mais compacta para cada card
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },
  cardTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "15px",
  },
  cardText: {
    fontSize: "14px",
    color: "#666",
    marginTop: "10px",
  },
  icon: {
    color: "inherit", // Remove a cor personalizada, mantendo a cor natural do ícone
  },
};

export default SolucoesInovadoras;
